var _rect, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 50,
    viewBox: "0 0 98 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 50,
    rx: 4,
    fill: "#F6F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4376 17V17.0074C38.43 17.0074 36.0549 17 35.4215 19.2345C34.8409 21.2834 33.2047 26.9402 33.1595 27.0961H32.707C32.707 27.0961 31.0331 21.3131 30.445 19.2271C29.8116 16.9926 27.4289 17 27.4289 17H22V34H27.4289V23.9039H27.8813L31.0482 34H34.8183L37.9852 23.9114H38.4376V34H43.8665V17H38.4376Z",
    fill: "#4DB45E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2682 17C58.2682 17 56.6773 17.1411 55.9308 18.7817L52.0853 27.0961H51.6329V17H46.204V34H51.3313C51.3313 34 52.9977 33.8515 53.7441 32.2183L57.5142 23.9039H57.9666V34H63.3955V17H58.2682Z",
    fill: "#4DB45E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8084 24.7205V34H71.2373V28.5808H77.1187C79.6823 28.5808 81.8539 26.9699 82.6607 24.7205H65.8084Z",
    fill: "#4DB45E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1187 17H65.0468C65.6501 20.2367 68.1157 22.8349 71.3052 23.6812C72.029 23.8742 72.7906 23.9782 73.5748 23.9782H82.8794C82.9623 23.5921 83 23.1987 83 22.7904C83 19.5908 80.3685 17 77.1187 17Z",
    fill: "url(#paint0_linear_3823_44177)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3823_44177",
    x1: 65.0483,
    y1: 20.4891,
    x2: 83,
    y2: 20.4891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088CCB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/Mir.svg";
export { ForwardRef as ReactComponent };